import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

import { Button, Card, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import ModalActions from 'components/ModalActions';
import { Field, Formik } from 'formik';
import { ALPACLASS_CONTENT_URL, ALPACLASS_URL } from 'settings';
import UrlValidationFormField from 'v2/components/Shared/UrlValidationFormField';
import deliveryProvidersService from 'v2/services/delivery-providers';
import * as yup from 'yup';

const alpaclassObject = {
  id: 47,
  method_id: '47',
  method_name: 'AlpaClass',
  name: 'AlpaClass',
  parameters: { label: 'URL', name: 'url', regexp: '', required: true, size: 250 },
  type: 'CHECKOUT',
  url: ''
};
const urlRegex =
  /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;

interface IProps {
  isModal: boolean;
  open?: boolean;
  onClose?: any;
  onOk: any;
  other?: any;
  offer?: any;
  newProduct?: boolean;
  deliveries?: IDelivery[];
}
interface IDelivery {
  id: number;
  method_id: number;
  method_name: string;
  url: string;
  can_modify: boolean;
}

// TODO: migrate to react-hook-form and zod while preserving URL validation.
const AlpaClass: React.FC<IProps> = ({ isModal, open, onClose, onOk, other, deliveries }) => {
  const [selected, setSelected] = useState<any>(() =>
    other ? Object.assign({}, { ...alpaclassObject, ...other }) : Object.assign({}, alpaclassObject)
  );
  const [urlIsValid, setUrlIsValid] = useState(false);

  const handleClose = useCallback(() => {
    onClose();
    setSelected(Object.assign({}, alpaclassObject));
  }, [onClose]);

  const handleOk = useCallback(() => {
    let isValid = true;
    const url = urlRegex.test(String(selected.url).toLowerCase());

    if (!url) {
      toast.warn('Por favor informe uma Url válida no campo URL');
      isValid = false;
    }

    const alreadyExistsUrl = deliveries?.findIndex((d: any) => d.url === selected.url) !== -1;

    if (alreadyExistsUrl) {
      toast.warn('URL já adicionada');
      return;
    }

    if (selected?.id) {
      if (isValid) {
        if (onOk) {
          selected.new = true;
          selected.can_modify = true;
          onOk(selected, other);
          if (!other) toast.success(`Item ${selected.name} adicionado com sucesso!`);
          setSelected(Object.assign({}, alpaclassObject));
          onClose();
        }
      } else {
        /* already toasted */
      }
    } else {
      toast.warn('Por favor selecione uma forma de entrega do tipo outros');
    }
  }, [selected, onOk, other, onClose, deliveries]);

  const isOkButtonDisabled = useCallback(() => !urlIsValid, [urlIsValid]);

  const title = 'Entrega de conteúdo na AlpaClass';
  const content = (
    <form>
      <div className='w-full'>
        <Formik
          key='alpaclass-delivery'
          initialValues={{ url: selected.url, type: 'url' }}
          validateOnBlur
          validateOnChange
          validationSchema={yup.object().shape({
            url: yup
              .string()
              .required('Preencha o campo URL, obrigatório http:// ou https://')
              .url('Insira uma URL válida, obrigatório http:// ou https://')
              .test(
                'dominio-especifico',
                `A URL deve começar com ${ALPACLASS_CONTENT_URL}`,
                value => !!value && !!ALPACLASS_CONTENT_URL && value.startsWith(ALPACLASS_CONTENT_URL)
              )
          })}
          onSubmit={values => alert(JSON.stringify(values, null, 2))}
        >
          <div>
            <Field
              name='url'
              helperText={`Insira uma URL válida, deve começar com ${ALPACLASS_CONTENT_URL}`}
              id={alpaclassObject.parameters.name}
              component={UrlValidationFormField}
              afterValidate={
                <Typography.Paragraph className='mb-0'>
                  Ainda não tem conta na AlpaClass?{' '}
                  <Typography.Link href={ALPACLASS_URL} target='_blank' rel='noopener noreferrer'>
                    Clique Aqui
                  </Typography.Link>
                </Typography.Paragraph>
              }
              onValidateUrl={(isValid: boolean, url: string) => {
                setUrlIsValid(isValid);
                setSelected((prev: any) => ({ ...prev, url }));
              }}
              validateUrlCallback={deliveryProvidersService.customTestUrl}
            />
          </div>
        </Formik>
      </div>
    </form>
  );

  return (
    <div>
      {isModal ? (
        <ModalActions
          buttonOk='Salvar'
          buttonOkDisabled={isOkButtonDisabled()}
          title={title}
          open={open}
          onClose={handleClose}
          onOk={handleOk}
        >
          {content}
        </ModalActions>
      ) : (
        <Card title={title} extra={<Button type='text' icon={<Icon.X  />} />}>
          {content}
        </Card>
      )}
    </div>
  );
};

export default AlpaClass;
